const MIN_PARTICLES = 8;
const MAX_PARTICLES = 20;

export function createCurrent(width, height, direction = 1) {
    const span = Math.max(Number(width) || 0, 1);
    const depth = Math.max(Number(height) || 0, 1);
    const travel = direction >= 0 ? 1 : -1;

    return {
        driftX: travel * span * 0.22,
        driftY: depth * 0.08,
        duration: Math.min(22, Math.max(12, span / 90)),
        sway: Math.min(14, Math.max(8, span / 120)),
    };
}

export function particleCountForTank(width, height) {
    const area = Math.max(Number(width) || 0, 0) * Math.max(Number(height) || 0, 0);
    if (area <= 0) return MIN_PARTICLES;
    return Math.round(Math.min(MAX_PARTICLES, Math.max(MIN_PARTICLES, area / 85000)));
}

export function createParticles(count, random = Math.random) {
    return Array.from({ length: count }, (_, index) => ({
        id: index,
        left: random() * 100,
        top: random() * 72 + 8,
        size: random() * 4 + 4,
        delay: random() * -18,
        durationScale: random() * 0.55 + 0.7,
        opacity: random() * 0.35 + 0.6,
    }));
}
